'use strict';

function ContactImportController(contactService, $location, $q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.upload = upload;
  vm.deleteContact = deleteContact;

  function $onInit() {
    vm.visibility = { file: true, table: false };
    loadContacts();
  }

  function upload(csv) {

    return contactService.contactCsvImport(csv)
      .then(function(response) {
        vm.badFile = false;
        vm.badRows =  [];
        if (response.data.bad_rows.length > 0) {
          vm.badRows = response.data.bad_rows;
          return response;
        }
        else {
          var promises = response.data.contacts.map(function(contact) {
            return contactService.createContact(contact.contact, true);
          });
          $q.all(promises).then(function(){
            loadContacts();
          });
        }
        return response;
      })
      .catch(function() {
        vm.badFile = true;
        vm.badRows =  [];
      });
  }

  function deleteContact(contact) {
    contactService.deleteContact(contact)
      .then(function() {
        loadContacts();
      });
  }

  function loadContacts() {
    contactService.listContacts(true).then(function(response) {
      vm.contacts = response.data;
    });
  }
}

module.exports = ContactImportController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/contact-import/contact-import.controller.js
 ** module id = 147
 ** module chunks = 0
 **/